import * as yup from 'common/yup';
import {CommonReportParams} from 'types/diplomat/reports/CommonReportParams';

export const AuditReportParametersNames = {
   byTransactionName: 'byTransactionName',
   containing: 'containing',
   containingText: 'containingText',
   filenameContaining: 'filenameContaining',
   filenameContainingText: 'filenameContainingText',
   includeArchive: 'includeArchive',
   transactionNames: 'transactionNames',
} as const;

export const AuditReportParameters = yup
   .object({
      [AuditReportParametersNames.byTransactionName]: yup.bool(),
      [AuditReportParametersNames.containing]: yup.bool(),
      [AuditReportParametersNames.containingText]: yup.string(),
      [AuditReportParametersNames.filenameContaining]: yup.bool(),
      [AuditReportParametersNames.filenameContainingText]: yup.string(),
      [AuditReportParametersNames.includeArchive]: yup.bool(),
      [AuditReportParametersNames.transactionNames]: yup.array().of(yup.string()),
   })
   .concat(CommonReportParams);

export type IAuditReportParameters = yup.InferType<typeof AuditReportParameters>;
